import layout_ru_RU from '../../layout/translations/layout_ru_RU';
import sidebar_ru_RU from '../../layout/components/menu/translations/sidebar_ru_RU';
import users_ru_RU from '../../domains/RBAC/translations/Users/users_ru_RU';
import roles_ru_RU from '../../domains/RBAC/translations/Roles/roles_ru_RU';
import permissions_ru_RU from '../../domains/RBAC/translations/Permissions/permissions_ru_RU';
import profile_ru_RU from '../../domains/Profile/translations/Profile/profile_ru_RU';
import languages_ru_RU from '../../domains/Translations/translations/languages_ru_RU';
import structures_ru_RU from '../../domains/Translations/translations/structures_ru_RU';
import dictionaries_ru_RU from '../../domains/Translations/translations/dictionaries_ru_RU';
import translations_ru_RU from '../../domains/Translations/translations/translations_ru_RU';
import pushIcons_ru_RU from '../../domains/Other/translations/pushIcons_ru_RU';
import content_ru_RU from '../../domains/Content/translations/content_ru_RU';
import deeplinks_ru_RU from '../../domains/Other/translations/deeplinks_ru_RU';
import static_content_reset_ru_RU from '../../domains/Other/translations/static_content_reset_ru_RU';
import news_ru_RU from '../../domains/Content/translations/news_ru_RU';
import newsPriority_ru_RU from '../../domains/Content/translations/newsPriority_ru_RU';
import templates_ru_RU from '../../domains/Template builder/translations/templates_ru_RU';
import dynamicNews_ru_RU from '../../domains/Content/translations/dynamicNews_ru_RU';
import categories_ru_RU from '../../domains/Content/translations/categories_ru_RU';
import achievements_ru_RU from '../../domains/Content/translations/achievements_ru_RU';
import bonuses_ru_RU from '../../domains/Content/translations/bonuses_ru_RU';
import features_ru_RU from '../../domains/Featured/translations/features_ru_RU';
import featuresPriority_ru_RU from '../../domains/Featured/translations/featuresPriority_ru_RU';
import presets_ru_RU from '../../domains/Template builder/translations/presets_ru_RU';
import popups_ru_RU from '../../domains/Other/translations/popups_ru_RU';
import logs_ru_RU from '../../domains/RBAC/translations/Logs/logs_ru_RU';
import collections_ru_RU from '../../domains/Content/translations/collections_ru_RU';
import feeds_ru_RU from '../../domains/Content/translations/feeds_ru_RU';
import images_ru_RU from '../../domains/Content/translations/images_ru_RU';
import localNotifications_ru_RU from '../../domains/Other/translations/localNotifications_ru_RU';
import pushNotifications_ru_RU from '../../domains/Other/translations/pushNotifications_ru_RU';
import pushNotificationsSchedule_ru_RU from '../../domains/Other/translations/pushNotificationsSchedule_ru_RU';



const ru_RU = {
  'ui-general-search': 'Поиск...',
  'ui-general-search-by-title': 'Поиск по названию...',
  'ui-general-action': 'Действие',
  'ui-general-empty': 'Пусто',
  'ui-general-show': 'Показать',
  'ui-general-back': 'Назад',
  'ui-general-back-to-list': 'Назад к списку',
  'ui-general-template-data': 'Данные шаблона',
  'ui-general-additional-parameters': 'Дополнительные параметры',
  'ui-general-optional-data': 'Опциональные данные',
  'ui-general-edit': 'Редактировать',
  'ui-general-back-to-view': 'К просмотру',
  'ui-general-save': 'Сохранить',
  'ui-general-save-and-publish': 'Сохранить и опубликовать',
  'ui-general-update': 'Обновить',
  'ui-general-view': 'Посмотреть',
  'ui-general-create': 'Создать',
  'ui-general-remove': 'Удалить',
  'ui-general-delete': 'Удалить',
  'ui-general-bee-id': 'Bee ID',
  'ui-general-id': 'ID',
  'ui-general-app-id': 'App ID',
  'ui-general-ids-placeholder': 'Введите Id(s)',
  'ui-general-id-placeholder': 'Введите Id',
  'ui-general-min': 'Мин.',
  'ui-general-max': 'Макс.',
  'ui-general-min-version': 'Мин. версия',
  'ui-general-max-version': 'Макс. версия',
  'ui-general-platform': 'Платформа',
  'ui-general-choose-platform': 'Выберите платформу',
  'ui-general-countries': 'Страны',
  'ui-general-choose-countries': 'Выберите страны',
  'ui-general-preview': 'Предпросмотр',
  'ui-general-content': 'Контент',
  'ui-general-title': 'Название',
  'ui-general-status': 'Статус',
  'ui-general-image': 'Изображение',
  'ui-general-category': 'Категория',
  'ui-general-content-type': 'Тип контента',
  'ui-general-content-type-placeholder': 'Выберите тип контента',
  'ui-general-storage-images': 'Хранилище',
  'ui-general-action-storage': 'В хранилище',
  'ui-general-planning-images': 'Доска планирования',
  'ui-general-ready-release-on': 'Опубликованные',
  'ui-general-priority': 'Приоритет',
  'ui-general-main-info': 'Основная информация',
  'ui-general-template': 'Шаблон',
  'ui-general-user': 'Пользователь',
  'ui-general-type': 'Тип',
  'ui-general-format': 'Формат',
  'ui-general-choose-type': 'Выберите тип',
  'ui-general-specify-title': 'Введите название',
  'ui-general-choose-template': 'Выберите шаблон',
  'ui-general-choose-labels': 'Выберите лэйблы',
  'ui-general-choose-hashtags': 'Выберите хештеги',
  'ui-general-choose-status': 'Выберите статус',
  'ui-general-choose-content-type': 'Выберите тип контента',
  'ui-general-preset': 'Пресет',
  'ui-general-choose-preset': 'Выберите пресет',
  'ui-general-specify-value': 'Введите значение',
  'ui-general-cancel': 'Отмена',
  'ui-general-dictionary': 'Словарь',
  'ui-general-categories': 'Категории',
  'ui-general-choose-categories': 'Выберите категории',
  'ui-general-name': 'Имя',
  'ui-general-specify-name': 'Укажите название',
  'ui-general-not-published': 'Не опубликовано',
  'ui-general-display-name': 'Отображаемое имя',
  'ui-general-description': 'Описание',
  'ui-general-specify-description': 'Добавьте описание',
  'ui-general-submit': 'Подтвердить',
  'ui-general-apply': 'Применить',
  'ui-general-copied': 'Скопировано',
  'ui-general-copy': 'Копировать',
  'ui-general-img-copy': 'Копия',
  'ui-general-img-reopened': 'Переоткрыто',
  'ui-general-reset': 'Сбросить',
  'ui-general-reset-changes': 'Сбросить изменения',
  'ui-general-download': 'Скачать',
  'ui-general-reopen': 'Переоткрыть',
  'ui-general-clone': 'Клонировать',
  'ui-general-import': 'Импорт',
  'ui-general-export': 'Экспорт',
  'ui-general-ok': 'Ок',
  'ui-general-created-successfully': 'Данные успешно созданы',
  'ui-general-create-failed': 'Ошибка при создании данных',
  'ui-general-updated-successfully': 'Данные успешно обновлены',
  'ui-general-update-failed': 'Ошибка при редактировании данных',
  'ui-general-deleted-successfully': 'Данные успешно удалены',
  'ui-general-delete-failed': 'Ошибка при удалении данных',
  'ui-general-logout': 'Выход',
  'ui-general-yes': 'Да',
  'ui-general-no': 'Нет',
  'ui-general-required': 'Обязательно',
  'ui-general-optional': 'Необязателен',
  'ui-general-validation-required': 'Заполните поле',
  'ui-general-label': 'Название',
  'ui-general-labels': 'Лэйблы',
  'ui-general-hashtags': 'Хештеги',
  'ui-general-created-from': 'Создан с',
  'ui-general-created-to': 'Создан по',
  'ui-general-created-at': 'Дата создания',
  'ui-general-updated-at': 'Дата изменения',
  'ui-general-published-at': 'Опубликовано',
  'ui-general-scheduled-at': 'Время публикации',
  'ui-general-filter-scheduled-at': 'Отправка с',
  'ui-general-filter-scheduled-to': 'Отправка по',
  'ui-general-roles': 'Роли',
  'ui-general-filter': 'Фильтр',
  'ui-general-permissions': 'Права доступа',
  'ui-general-code': 'Код',
  'ui-general-specify-code': 'Укажите код',
  'ui-general-specify-codes': 'Укажите код(ы)',
  'ui-general-languages': 'Языки',
  'ui-general-choose-languages': 'Выберите языки',
  'ui-general-structures': 'Структуры',
  'ui-general-dictionaries': 'Словари',
  'ui-general-list': 'Список',
  'ui-general-catalog': 'Каталог',
  'ui-general-delete-confirm-message': 'Вы уверены, что хотите удалить эти данные?',
  'ui-general-total': 'Всего',
  'ui-general-selected': 'Выбрано',
  'ui-general-loading': 'Загрузка. Ожидайте...',
  'ui-general-success': 'Успех',
  'ui-general-error': 'Ошибка',
  'ui-general-all': 'Все',
  'ui-general-on': 'Вкл',
  'ui-general-off': 'Выкл',
  'ui-general-restricted': 'У вас нет прав чтобы произвести данное действие',
  'ui-general-attach-image': 'Прикрепить картинку',
  'ui-general-attach-image-click': 'Нажмите на картинку, чтобы прикрепить',
  'ui-general-detach-image': 'Открепить картинку',
  'ui-general-no-images-found': 'Картинки не найдены',
  'ui-general-published-from': 'Опубликован с',
  'ui-general-published-to': 'Опубликован по',
  'ui-general-released-at': 'Релиз с',
  'ui-general-released-to': 'Релиз по',
  'ui-general-release-date': 'Дата релиза',
  'ui-general-published': 'Опубликовано',
  'ui-general-publish': 'К публикации',
  'ui-general-editing': 'Редактируется',
  'ui-general-invalid-date': 'Некорректная дата',
  'ui-general-documentation-link': 'Ссылка на документацию',
  'ui-general-without-category': 'Без категории',
  'ui-general-without-tag': 'Без тегов',
  'ui-general-select-all': 'Выбрать все',
  'ui-general-doc-link-notification': 'Документацию по данному разделу можно найти здесь:',
  'ui-general-filter-id-key-help': 'Разрешено вводить ID через запятые или пробелы',
  'ui-general-filter-code-key-help': 'Разрешено вводить Коды через запятые или пробелы',
  'ui-general-upload-image': 'Загрузить изображение',
  'ui-general-was-not-published': 'Данные ни разу не публиковались',
  'ui-general-last-published-at': 'Дата последней публикации',
  'ui-general-unpublish': 'Снять с публикации',
  'ui-general-trash': 'В корзину',
  'ui-general-archive': 'Архивировать',
  'ui-general-info': 'Общая информация',
  'ui-general-tags': 'Теги',
  'ui-general-similar-images': 'Похожие изображения',
  'ui-general-unpublished-successfully': 'Успешно снято с публикации',
  'ui-general-unpublish-failed': 'Ошибка при снятии с публикации',
  'ui-general-unpublished-tooltip-title': 'Имеются неопубликованные изменения',
  'ui-general-unable-delete-published-item-notification': 'Удаление невозможно, данная запись уже опубликована',
  'ui-general-image-preview': 'Просмотр картинки',
  'ui-general-no-attached-images': 'Данная запись не содержит прикрепленных картинок',
  'ui-general-targets': 'Назначение',
  'ui-general-comment': 'Комментарий',
  'ui-general-not-selected': 'Не выбрано',
  'ui-general-jan-short': 'Янв',
  'ui-general-feb-short': 'Фев',
  'ui-general-mar-short': 'Мар',
  'ui-general-apr-short': 'Апр',
  'ui-general-may-short': 'Май',
  'ui-general-jun-short': 'Июн',
  'ui-general-jul-short': 'Июл',
  'ui-general-aug-short': 'Авг',
  'ui-general-sep-short': 'Сен',
  'ui-general-oct-short': 'Окт',
  'ui-general-nov-short': 'Ноя',
  'ui-general-dec-short': 'Дек',
  'ui-general-publication-time': 'Время публикации',
  'ui-general-cancel-confirmation': 'Вы уверены, что хотите отменить изменения и выйти без сохранения?',
  'ui-general-or': 'или',
  'ui-general-leave-changes-confirm-message': 'Вы уверены, что хотите оставить несохраненные изменения?',
  'ui-general-leave-changes-confirm-modal-title': 'Несохраненные изменения',
  'ui-general-warning': 'Внимание',
  'ui-general-default': 'По умолчанию',
  'ui-general-used-as-default': 'Используется по умолчанию',
  'ui-general-html': 'HTML',
  'ui-general-specify-html': 'Введите HTML код',
  'ui-general-no-data-placeholder': 'Нет данных',
  'ui-general-scale': 'Масштаб',
  'ui-general-other': 'Другое',
  'ui-general-utc-from': 'UTC от',
  'ui-general-utc-to': 'UTC до',
  'ui-general-use-utc': 'Использовать UTC+0',
  'ui-general-targets-min-version-placeholder': 'Минимальная версия приложения',
  'ui-general-targets-max-version-placeholder': 'Максимальная версия приложения',
  'ui-general-use-utc-info': 'Данный параметр влияет на то, в какое время пользователь получит контент, в конкретное время сервера (вкл) или в конкретное время пользователя (выкл)',
  'ui-general-edit-has-changes': 'Информируем о наличии обновлений для мобильного приложения HappyColor. Для успешной публикации этих изменений пользователю необходимо отметить соответствующий чекбокс, расположенный в правом нижнем углу экрана, рядом с кнопкой "Сохранить".',
  'ui-general-publish-changes': 'Опубликовать изменения',
  'ui-general-push-notification': 'Серверные уведомления',
  ...layout_ru_RU,
  ...news_ru_RU,
  ...sidebar_ru_RU,
  ...features_ru_RU,
  ...users_ru_RU,
  ...roles_ru_RU,
  ...permissions_ru_RU,
  ...profile_ru_RU,
  ...languages_ru_RU,
  ...structures_ru_RU,
  ...dictionaries_ru_RU,
  ...translations_ru_RU,
  ...pushIcons_ru_RU,
  ...deeplinks_ru_RU,
  ...static_content_reset_ru_RU,
  ...content_ru_RU,
  ...newsPriority_ru_RU,
  ...templates_ru_RU,
  ...dynamicNews_ru_RU,
  ...categories_ru_RU,
  ...achievements_ru_RU,
  ...featuresPriority_ru_RU,
  ...presets_ru_RU,
  ...popups_ru_RU,
  ...bonuses_ru_RU,
  ...logs_ru_RU,
  ...collections_ru_RU,
  ...feeds_ru_RU,
  ...images_ru_RU,
  ...localNotifications_ru_RU,
  ...pushNotifications_ru_RU,
  ...pushNotificationsSchedule_ru_RU,
};

export default ru_RU;
